interface Master {[key: string]: {ja: string, en: string}}

export const getLabelWithCode = (master: Master, key: string, lang: 'ja' | 'en'): string => {
  return `${key.toString().toLowerCase()} ${(master[key.toString().toLowerCase()]?.[lang] || '')}`
}
